import { useState, useRef, useEffect } from 'react';

const QUICK_EMOJIS = ['👍', '❤️', '😂', '😮', '😢', '🎉'];

const EMOJI_CATEGORIES = [
  { name: '자주 사용', emojis: ['👍', '❤️', '😂', '😮', '😢', '🎉', '🔥', '👀', '💯', '✅'] },
  { name: '표정', emojis: ['😀', '😃', '😄', '😁', '😆', '😅', '🤣', '😊', '😇', '🙂', '😉', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '😋', '😛'] },
  { name: '손', emojis: ['👋', '🤚', '✋', '👌', '✌️', '🤞', '🤟', '🤘', '🤙', '👈', '👉', '👆', '👇', '👍', '👎', '👏', '🙌', '🤝', '🙏', '💪'] },
  { name: '기호', emojis: ['❤️', '🧡', '💛', '💚', '💙', '💜', '🖤', '💔', '💕', '💗', '⭐', '🌟', '✨', '💫', '🎯', '🎪', '🏆', '🥇', '🎖️', '🏅'] },
];

interface Props {
  onSelect: (emoji: string) => void;
  onClose: () => void;
}

export default function EmojiPicker({ onSelect, onClose }: Props) {
  const [expanded, setExpanded] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handle = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) onClose();
    };
    document.addEventListener('mousedown', handle);
    return () => document.removeEventListener('mousedown', handle);
  }, [onClose]);

  return (
    <div ref={ref}
      className="bg-white rounded-xl shadow-lg border border-gray-200 p-2 w-[220px]">
      {/* Quick emojis */}
      <div className="flex gap-0.5 mb-1">
        {QUICK_EMOJIS.map((e) => (
          <button key={e} onClick={() => onSelect(e)}
            className="w-8 h-8 flex items-center justify-center rounded hover:bg-gray-100 text-lg transition-colors">
            {e}
          </button>
        ))}
      </div>

      {/* Expand toggle */}
      {!expanded ? (
        <button onClick={() => setExpanded(true)}
          className="w-full py-1 text-[11px] text-gray-400 hover:text-gray-600 border-t border-gray-100">
          전체 이모지 ▼
        </button>
      ) : (
        <div className="border-t border-gray-100 pt-1 max-h-48 overflow-y-auto">
          {EMOJI_CATEGORIES.map((cat) => (
            <div key={cat.name} className="mb-2">
              <p className="text-[11px] text-gray-400 mb-0.5 px-1">{cat.name}</p>
              <div className="grid grid-cols-7 gap-0.5">
                {cat.emojis.map((e) => (
                  <button key={e} onClick={() => onSelect(e)}
                    className="w-7 h-7 flex items-center justify-center rounded hover:bg-gray-100 text-base transition-colors">
                    {e}
                  </button>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
